import Animation from "./class.Animation.js";
import FadeIn from "./class.FadeIn.js";

/**
 * A list of all the enumerable animation classes.
 * If you make a new animation, add it here!!!!!
 */
export default {
	Animation,
	FadeIn,
};
